const bricotheque = (data) => {
	const bricotheques = data.map(
		({ id, title: { rendered: title }, content: { rendered: content }, slug, acf: { type } }) => {
			return {
				id,
				slug,
				title,
				content,
				type,
			}
		},
	)

	return bricotheques.reverse()
}

export default bricotheque
